export const ConfigurationId = 'ConfigurationId';

export interface Configuration {
  baseUrl: string;
  loginRedirect: string;
  appBase: string;
  appBaseUrl: string;
  /**
   * URL del frontend alcanzable desde dentro de la red de contenedores.
   * `appBaseUrl` es la del browser (pasa por el proxy) y desde el BFF resuelve
   * a loopback: misma distincion que `apiExternalBaseUrl` vs `apiInternalBaseUrl`.
   * Solo la usa el backend.
   */
  appInternalBaseUrl: string;
  bffBaseUrl: string;
  apiInternalBaseUrl: string;
  apiExternalBaseUrl: string;
  version: string;
  environment?: string;
}

export class ConfigurationImpl implements Configuration {
  readonly #baseUrl: string;
  readonly #loginRedirect: string;
  readonly #appBase: string;
  readonly #appBaseUrl: string;
  readonly #appInternalBaseUrl: string;
  readonly #bffBaseUrl: string;
  readonly #apiInternalBaseUrl: string;
  readonly #apiExternalBaseUrl: string;
  readonly #version: string;
  readonly #environment: string;

  constructor({
    baseUrl,
    loginRedirect,
    appBase,
    appBaseUrl,
    appInternalBaseUrl,
    bffBaseUrl,
    apiInternalBaseUrl,
    apiExternalBaseUrl,
    version,
    environment,
  }: Partial<Configuration>) {
    this.#baseUrl = <string>baseUrl;
    this.#loginRedirect = <string>loginRedirect;
    this.#appBase = <string>appBase;
    this.#appBaseUrl = <string>appBaseUrl;
    this.#appInternalBaseUrl = <string>appInternalBaseUrl;
    this.#bffBaseUrl = <string>bffBaseUrl;
    this.#apiInternalBaseUrl = <string>apiInternalBaseUrl;
    this.#apiExternalBaseUrl = <string>apiExternalBaseUrl;
    this.#version = <string>version;
    this.#environment = <string>environment;
  }

  get baseUrl(): string {
    return this.#baseUrl;
  }

  get loginRedirect(): string {
    return this.#loginRedirect;
  }

  get appBase(): string {
    return this.#appBase;
  }

  get appBaseUrl(): string {
    return this.#appBaseUrl;
  }

  get appInternalBaseUrl(): string {
    return this.#appInternalBaseUrl;
  }

  get bffBaseUrl(): string {
    return this.#bffBaseUrl;
  }

  get apiInternalBaseUrl(): string {
    return this.#apiInternalBaseUrl;
  }

  get apiExternalBaseUrl(): string {
    return this.#apiExternalBaseUrl;
  }

  get version(): string {
    return this.#version;
  }

  get environment(): string {
    return this.#environment;
  }
}
